import React from 'react';
import { Box, Tooltip } from '@mui/material';
import { depthReading } from './depthReading';

// DWLF-416: the depth reading as a badge. IN ZONE is filled and bold; the rest are outlined, and
// "Not reached" is quiet text. No reading shows as an em dash (or nothing, with `hideEmpty`). Inside a
// button (`focusable={false}`) it takes no focus stop of its own and adds only its label to the button's name:
// its own aria-label overrides the one MUI's Tooltip would give it (the whole tooltip sentence).
const TONES = {
  loud: { backgroundColor: 'var(--dwlf-accent)', color: 'var(--dwlf-on-accent)', fontWeight: 700, border: '1px solid var(--dwlf-accent)' },
  muted: { color: 'var(--dwlf-ink-70)', border: '1px solid var(--dwlf-ink-20)' },
  quiet: { color: 'var(--dwlf-ink-35)', border: '1px solid transparent' },
};

export default function DepthBadge({ depth, side, hideEmpty = false, focusable = true }) {
  const r = depthReading(depth, side);
  if (!r) return hideEmpty ? null : <Box component="span" sx={{ color: 'var(--dwlf-ink-35)' }}>—</Box>;
  return (
    <Tooltip title={r.detail} placement="top" enterTouchDelay={0} leaveTouchDelay={5000}>
      <Box
        component="span"
        data-depth-position={r.position}
        {...(focusable ? { tabIndex: 0, 'aria-label': `Depth: ${r.label}. ${r.detail}` } : { 'aria-label': `Depth ${r.label}` })}
        sx={{
          display: 'inline-block', px: 0.75, py: 0.25, whiteSpace: 'nowrap',
          fontFamily: '"Space Mono", monospace', fontSize: '0.6875rem', letterSpacing: '0.08em', textTransform: 'uppercase',
          ...TONES[r.tone],
        }}
      >
        {r.label}
      </Box>
    </Tooltip>
  );
}
